var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-input",
    _vm._b(
      {
        class: { isView: _vm.mode !== "edit" },
        attrs: {
          value: _vm.inputVal,
          type: "textarea",
          rows: _vm.rows,
          "show-word-limit": _vm.showWordLimit,
          autocomplete: "off",
          clearable: "",
          resize: _vm.resize,
          placeholder: _vm.isDisabled ? "" : _vm.$t("common.pleaseInput"),
          disabled: _vm.isDisabled,
        },
        on: { input: _vm.onInput },
      },
      "el-input",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }